import { Button } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const ActionButtonStyled = styled(Button)`
  margin-bottom: 1.2rem;

  ${breakpointsMQ4.md.down} {
    width: 100%;
  }
`;
